import Layout from '@/layout'
import { checkCfsPermission } from '@/utils/permission'

const config = {
  path: '/partner',
  component: Layout,
  redirect: '/user/member',
  alwaysShow: true,
  name: 'partner',
  meta: {
    title: 'partner.label',
    icon: 'table'
  },
  hidden: false,
  children: [
    {
      path: 'contactUs',
      component: () => import('@/views/contactUs/contactUs'),
      name: 'contactUs',
      hidden: checkCfsPermission('CONTACT_US'),
      meta: { title: 'contactUs.label' }
    },
    {
      path: 'contactUs/edit',
      component: () => import('@/views/contactUs/contactUsEdit'),
      name: 'contactUsEdit',
      meta: {
        title: 'contactUs.label',
        noCache: false
      },
      hidden: true
    },
    {
      path: 'partnerReg',
      component: () => import('@/views/partner/partner'),
      name: 'partner',
      hidden: checkCfsPermission('CONTACT_US'),
      meta: { title: 'partnerReg.label' }
    }

  ]
}
export default config
